import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import CardIcon from '../CardIcon/CardIcon.js';
import { cardTypeOfCreditCardBrand } from '../../types-internal/index.js';
import styles from './SupportedCardList.module.scss.js';

/**
 * Render a list of card icons. Main usage at the moment is to be displayed above the credit card form.
 */
const SupportedCardList = ({ cardBrands, size }) => {
    return (jsx("div", { className: classNames(styles.cardsContainer, {
            [styles.smallCardsContainer]: size === 's',
        }), children: cardBrands.map((cardBrand) => (jsx(CardIcon, { className: classNames({ [styles.cardIconSmall]: size === 's' }), type: cardTypeOfCreditCardBrand[cardBrand] }, cardBrand))) }));
};

export { SupportedCardList as default };
//# sourceMappingURL=SupportedCardList.js.map
